import React from 'react';
import Utils from './Utils';
import { HashRouter, Route, Link, Routes } from 'react-router-dom'

import PageWrapper from './PageWrapper';
import { LowerContainer, LowerContainerBox } from './WelcomeScreen';
import { Nav, NavLink } from './PageWrapper';

import DaynaGenerateScript from './DaynaGenerateScript';

class HomeDisplay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      daynaTasks: '',
    }
  }

  componentDidMount() {
    Utils.apiGet('/dayna/view_all_scripts').then((response) => {
      this.setState({
        'daynaTasks': response.data.dayna_tasks,
      })
    })
  }

  linkFor(task_id) {
    let url = '/dayna/' + task_id
    return (
        <li><a href={url}>{task_id.replaceAll('[', '').replaceAll(']', '')}</a></li>
      )
  }

  render() {
    return (
      <div> Welcome! Please use this page to view current Dayna scripts and write new ones.
        {this.state.daynaTasks && 
          <div>
            <ul>
              {this.state.daynaTasks.split(', ').map((task_id) => {return(this.linkFor(task_id))})}
            </ul>
          </div>
        }
      </div>
    );
  }
}

const Tab = () => (
  <Nav style={{'backgroundColor': 'transparent', 'textDecoration': 'none', 'justifyContent': 'space-evenly'}}>
    <Link style={{'paddingRight': '20px'}} to='/'>Home</Link>
    <Link style={{'paddingRight': '20px'}} to='/new_script'>Write a New Dayna Script</Link>
  </Nav>
)

const Pane = () => {
  return (
    <Routes>
      <Route path='/' element={<HomeDisplay />}/>
      <Route path='/new_script' element={<DaynaGenerateScript />}/>
    </Routes>
  )
}

class DaynaHome extends React.Component {
  constructor(props) {
    super(props);
  }
  
  componentDidMount() {
  }
  
  render() {
    return (
      <HashRouter hashType="noslash">
        <PageWrapper isAdmin={this.props.isAdmin} noContainer={true}>
          <LowerContainer>
            <Tab />
            <Pane />
          </LowerContainer>
        </PageWrapper>
      </HashRouter>
    );
  }
}

export default DaynaHome;
